export const templateLanguages = [
  {
    "code": "aa",
    "alpha2": "aa",
    "alpha3": "aar",
    "family": "Afro-Asiatic",
    "name": "Afar",
    "nativeName": "Afaraf",
    "wikiUrl": "https://en.wikipedia.org/wiki/Afar_language",
    "flag": "🌐"
  },
  {
    "code": "ab",
    "alpha2": "ab",
    "alpha3": "abk",
    "family": "Northwest Caucasian",
    "name": "Abkhaz",
    "nativeName": "аҧсуа бызшәа, аҧсшәа",
    "wikiUrl": "https://en.wikipedia.org/wiki/Abkhaz_language",
    "flag": "🌐"
  },
  {
    "code": "ae",
    "alpha2": "ae",
    "alpha3": "ave",
    "family": "Indo-European",
    "name": "Avestan",
    "nativeName": "avesta",
    "wikiUrl": "https://en.wikipedia.org/wiki/Avestan_language",
    "flag": "🌐"
  },
  {
    "code": "af",
    "alpha2": "af",
    "alpha3": "afr",
    "family": "Indo-European",
    "name": "Afrikaans",
    "nativeName": "Afrikaans",
    "wikiUrl": "https://en.wikipedia.org/wiki/Afrikaans_language",
    "flag": "🌐"
  },
  {
    "code": "ak",
    "alpha2": "ak",
    "alpha3": "aka",
    "family": "Niger–Congo",
    "name": "Akan",
    "nativeName": "Akan",
    "wikiUrl": "https://en.wikipedia.org/wiki/Akan_language",
    "flag": "🌐"
  },
  {
    "code": "am",
    "alpha2": "am",
    "alpha3": "amh",
    "family": "Afro-Asiatic",
    "name": "Amharic",
    "nativeName": "አማርኛ",
    "wikiUrl": "https://en.wikipedia.org/wiki/Amharic_language",
    "flag": "🌐"
  },
  {
    "code": "an",
    "alpha2": "an",
    "alpha3": "arg",
    "family": "Indo-European",
    "name": "Aragonese",
    "nativeName": "aragonés",
    "wikiUrl": "https://en.wikipedia.org/wiki/Aragonese_language",
    "flag": "🌐"
  },
  {
    "code": "ar",
    "alpha2": "ar",
    "alpha3": "ara",
    "family": "Afro-Asiatic",
    "name": "Arabic",
    "nativeName": "العربية",
    "wikiUrl": "https://en.wikipedia.org/wiki/Arabic_language",
    "flag": "🇸🇦"
  },
  {
    "code": "as",
    "alpha2": "as",
    "alpha3": "asm",
    "family": "Indo-European",
    "name": "Assamese",
    "nativeName": "অসমীয়া",
    "wikiUrl": "https://en.wikipedia.org/wiki/Assamese_language",
    "flag": "🌐"
  },
  {
    "code": "av",
    "alpha2": "av",
    "alpha3": "ava",
    "family": "Northeast Caucasian",
    "name": "Avaric",
    "nativeName": "авар мацӀ, магӀарул мацӀ",
    "wikiUrl": "https://en.wikipedia.org/wiki/Avar_language",
    "flag": "🌐"
  },
  {
    "code": "ay",
    "alpha2": "ay",
    "alpha3": "aym",
    "family": "Aymaran",
    "name": "Aymara",
    "nativeName": "aymar aru",
    "wikiUrl": "https://en.wikipedia.org/wiki/Aymara_language",
    "flag": "🌐"
  },
  {
    "code": "az",
    "alpha2": "az",
    "alpha3": "aze",
    "family": "Turkic",
    "name": "Azerbaijani",
    "nativeName": "azərbaycan dili",
    "wikiUrl": "https://en.wikipedia.org/wiki/Azerbaijani_language",
    "flag": "🌐"
  },
  {
    "code": "ba",
    "alpha2": "ba",
    "alpha3": "bak",
    "family": "Turkic",
    "name": "Bashkir",
    "nativeName": "башҡорт теле",
    "wikiUrl": "https://en.wikipedia.org/wiki/Bashkir_language",
    "flag": "🌐"
  },
  {
    "code": "be",
    "alpha2": "be",
    "alpha3": "bel",
    "family": "Indo-European",
    "name": "Belarusian",
    "nativeName": "беларуская мова",
    "wikiUrl": "https://en.wikipedia.org/wiki/Belarusian_language",
    "flag": "🌐"
  },
  {
    "code": "bg",
    "alpha2": "bg",
    "alpha3": "bul",
    "family": "Indo-European",
    "name": "Bulgarian",
    "nativeName": "български език",
    "wikiUrl": "https://en.wikipedia.org/wiki/Bulgarian_language",
    "flag": "🌐"
  },
  {
    "code": "bh",
    "alpha2": "bh",
    "alpha3": "bih",
    "family": "Indo-European",
    "name": "Bihari",
    "nativeName": "भोजपुरी",
    "wikiUrl": "https://en.wikipedia.org/wiki/Bihari_languages",
    "flag": "🌐"
  },
  {
    "code": "bi",
    "alpha2": "bi",
    "alpha3": "bis",
    "family": "Creole",
    "name": "Bislama",
    "nativeName": "Bislama",
    "wikiUrl": "https://en.wikipedia.org/wiki/Bislama_language",
    "flag": "🌐"
  },
  {
    "code": "bm",
    "alpha2": "bm",
    "alpha3": "bam",
    "family": "Niger–Congo",
    "name": "Bambara",
    "nativeName": "bamanankan",
    "wikiUrl": "https://en.wikipedia.org/wiki/Bambara_language",
    "flag": "🌐"
  },
  {
    "code": "bn",
    "alpha2": "bn",
    "alpha3": "ben",
    "family": "Indo-European",
    "name": "Bengali, Bangla",
    "nativeName": "বাংলা",
    "wikiUrl": "https://en.wikipedia.org/wiki/Bengali_language",
    "flag": "🌐"
  },
  {
    "code": "bo",
    "alpha2": "bo",
    "alpha3": "bod",
    "family": "Sino-Tibetan",
    "name": "Tibetan Standard, Tibetan, Central",
    "nativeName": "བོད་ཡིག",
    "wikiUrl": "https://en.wikipedia.org/wiki/Standard_Tibetan",
    "flag": "🌐"
  },
  {
    "code": "br",
    "alpha2": "br",
    "alpha3": "bre",
    "family": "Indo-European",
    "name": "Breton",
    "nativeName": "brezhoneg",
    "wikiUrl": "https://en.wikipedia.org/wiki/Breton_language",
    "flag": "🌐"
  },
  {
    "code": "bs",
    "alpha2": "bs",
    "alpha3": "bos",
    "family": "Indo-European",
    "name": "Bosnian",
    "nativeName": "bosanski jezik",
    "wikiUrl": "https://en.wikipedia.org/wiki/Bosnian_language",
    "flag": "🌐"
  },
  {
    "code": "ca",
    "alpha2": "ca",
    "alpha3": "cat",
    "family": "Indo-European",
    "name": "Catalan",
    "nativeName": "català",
    "wikiUrl": "https://en.wikipedia.org/wiki/Catalan_language",
    "flag": "🌐"
  },
  {
    "code": "ce",
    "alpha2": "ce",
    "alpha3": "che",
    "family": "Northeast Caucasian",
    "name": "Chechen",
    "nativeName": "нохчийн мотт",
    "wikiUrl": "https://en.wikipedia.org/wiki/Chechen_language",
    "flag": "🌐"
  },
  {
    "code": "ch",
    "alpha2": "ch",
    "alpha3": "cha",
    "family": "Austronesian",
    "name": "Chamorro",
    "nativeName": "Chamoru",
    "wikiUrl": "https://en.wikipedia.org/wiki/Chamorro_language",
    "flag": "🌐"
  },
  {
    "code": "co",
    "alpha2": "co",
    "alpha3": "cos",
    "family": "Indo-European",
    "name": "Corsican",
    "nativeName": "corsu, lingua corsa",
    "wikiUrl": "https://en.wikipedia.org/wiki/Corsican_language",
    "flag": "🌐"
  },
  {
    "code": "cr",
    "alpha2": "cr",
    "alpha3": "cre",
    "family": "Algonquian",
    "name": "Cree",
    "nativeName": "ᓀᐦᐃᔭᐍᐏᐣ",
    "wikiUrl": "https://en.wikipedia.org/wiki/Cree_language",
    "flag": "🌐"
  },
  {
    "code": "cs",
    "alpha2": "cs",
    "alpha3": "ces",
    "family": "Indo-European",
    "name": "Czech",
    "nativeName": "čeština, český jazyk",
    "wikiUrl": "https://en.wikipedia.org/wiki/Czech_language",
    "flag": "🇨🇿"
  },
  {
    "code": "cu",
    "alpha2": "cu",
    "alpha3": "chu",
    "family": "Indo-European",
    "name": "Old Church Slavonic, Church Slavonic, Old Bulgarian",
    "nativeName": "ѩзыкъ словѣньскъ",
    "wikiUrl": "https://en.wikipedia.org/wiki/Old_Church_Slavonic",
    "flag": "🌐"
  },
  {
    "code": "cv",
    "alpha2": "cv",
    "alpha3": "chv",
    "family": "Turkic",
    "name": "Chuvash",
    "nativeName": "чӑваш чӗлхи",
    "wikiUrl": "https://en.wikipedia.org/wiki/Chuvash_language",
    "flag": "🌐"
  },
  {
    "code": "cy",
    "alpha2": "cy",
    "alpha3": "cym",
    "family": "Indo-European",
    "name": "Welsh",
    "nativeName": "Cymraeg",
    "wikiUrl": "https://en.wikipedia.org/wiki/Welsh_language",
    "flag": "🌐"
  },
  {
    "code": "da",
    "alpha2": "da",
    "alpha3": "dan",
    "family": "Indo-European",
    "name": "Danish",
    "nativeName": "dansk",
    "wikiUrl": "https://en.wikipedia.org/wiki/Danish_language",
    "flag": "🇩🇰"
  },
  {
    "code": "de",
    "alpha2": "de",
    "alpha3": "deu",
    "family": "Indo-European",
    "name": "German",
    "nativeName": "Deutsch",
    "wikiUrl": "https://en.wikipedia.org/wiki/German_language",
    "flag": "🇩🇪"
  },
  {
    "code": "dv",
    "alpha2": "dv",
    "alpha3": "div",
    "family": "Indo-European",
    "name": "Divehi, Dhivehi, Maldivian",
    "nativeName": "ދިވެހި",
    "wikiUrl": "https://en.wikipedia.org/wiki/Dhivehi_language",
    "flag": "🌐"
  },
  {
    "code": "dz",
    "alpha2": "dz",
    "alpha3": "dzo",
    "family": "Sino-Tibetan",
    "name": "Dzongkha",
    "nativeName": "རྫོང་ཁ",
    "wikiUrl": "https://en.wikipedia.org/wiki/Dzongkha_language",
    "flag": "🌐"
  },
  {
    "code": "ee",
    "alpha2": "ee",
    "alpha3": "ewe",
    "family": "Niger–Congo",
    "name": "Ewe",
    "nativeName": "Eʋegbe",
    "wikiUrl": "https://en.wikipedia.org/wiki/Ewe_language",
    "flag": "🌐"
  },
  {
    "code": "el",
    "alpha2": "el",
    "alpha3": "ell",
    "family": "Indo-European",
    "name": "Greek (modern)",
    "nativeName": "ελληνικά",
    "wikiUrl": "https://en.wikipedia.org/wiki/Greek_language",
    "flag": "🇬🇷"
  },
  {
    "code": "en",
    "alpha2": "en",
    "alpha3": "eng",
    "family": "Indo-European",
    "name": "English",
    "nativeName": "English",
    "wikiUrl": "https://en.wikipedia.org/wiki/English_language",
    "flag": "🇬🇧"
  },
  {
    "code": "eo",
    "alpha2": "eo",
    "alpha3": "epo",
    "family": "Constructed",
    "name": "Esperanto",
    "nativeName": "Esperanto",
    "wikiUrl": "https://en.wikipedia.org/wiki/Esperanto",
    "flag": "🌐"
  },
  {
    "code": "es",
    "alpha2": "es",
    "alpha3": "spa",
    "family": "Indo-European",
    "name": "Spanish",
    "nativeName": "Español",
    "wikiUrl": "https://en.wikipedia.org/wiki/Spanish_language",
    "flag": "🇪🇸"
  },
  {
    "code": "et",
    "alpha2": "et",
    "alpha3": "est",
    "family": "Uralic",
    "name": "Estonian",
    "nativeName": "eesti, eesti keel",
    "wikiUrl": "https://en.wikipedia.org/wiki/Estonian_language",
    "flag": "🌐"
  },
  {
    "code": "eu",
    "alpha2": "eu",
    "alpha3": "eus",
    "family": "Language isolate",
    "name": "Basque",
    "nativeName": "euskara, euskera",
    "wikiUrl": "https://en.wikipedia.org/wiki/Basque_language",
    "flag": "🌐"
  },
  {
    "code": "fa",
    "alpha2": "fa",
    "alpha3": "fas",
    "family": "Indo-European",
    "name": "Persian (Farsi)",
    "nativeName": "فارسی",
    "wikiUrl": "https://en.wikipedia.org/wiki/Persian_language",
    "flag": "🇮🇷"
  },
  {
    "code": "ff",
    "alpha2": "ff",
    "alpha3": "ful",
    "family": "Niger–Congo",
    "name": "Fula, Fulah, Pulaar, Pular",
    "nativeName": "Fulfulde, Pulaar, Pular",
    "wikiUrl": "https://en.wikipedia.org/wiki/Fula_language",
    "flag": "🌐"
  },
  {
    "code": "fi",
    "alpha2": "fi",
    "alpha3": "fin",
    "family": "Uralic",
    "name": "Finnish",
    "nativeName": "suomi, suomen kieli",
    "wikiUrl": "https://en.wikipedia.org/wiki/Finnish_language",
    "flag": "🇫🇮"
  },
  {
    "code": "fj",
    "alpha2": "fj",
    "alpha3": "fij",
    "family": "Austronesian",
    "name": "Fijian",
    "nativeName": "vosa Vakaviti",
    "wikiUrl": "https://en.wikipedia.org/wiki/Fijian_language",
    "flag": "🌐"
  },
  {
    "code": "fo",
    "alpha2": "fo",
    "alpha3": "fao",
    "family": "Indo-European",
    "name": "Faroese",
    "nativeName": "føroyskt",
    "wikiUrl": "https://en.wikipedia.org/wiki/Faroese_language",
    "flag": "🌐"
  },
  {
    "code": "fr",
    "alpha2": "fr",
    "alpha3": "fra",
    "family": "Indo-European",
    "name": "French",
    "nativeName": "français, langue française",
    "wikiUrl": "https://en.wikipedia.org/wiki/French_language",
    "flag": "🇫🇷"
  },
  {
    "code": "fy",
    "alpha2": "fy",
    "alpha3": "fry",
    "family": "Indo-European",
    "name": "Western Frisian",
    "nativeName": "Frysk",
    "wikiUrl": "https://en.wikipedia.org/wiki/West_Frisian_language",
    "flag": "🌐"
  },
  {
    "code": "ga",
    "alpha2": "ga",
    "alpha3": "gle",
    "family": "Indo-European",
    "name": "Irish",
    "nativeName": "Gaeilge",
    "wikiUrl": "https://en.wikipedia.org/wiki/Irish_language",
    "flag": "🌐"
  },
  {
    "code": "gd",
    "alpha2": "gd",
    "alpha3": "gla",
    "family": "Indo-European",
    "name": "Scottish Gaelic, Gaelic",
    "nativeName": "Gàidhlig",
    "wikiUrl": "https://en.wikipedia.org/wiki/Scottish_Gaelic_language",
    "flag": "🌐"
  },
  {
    "code": "gl",
    "alpha2": "gl",
    "alpha3": "glg",
    "family": "Indo-European",
    "name": "Galician",
    "nativeName": "galego",
    "wikiUrl": "https://en.wikipedia.org/wiki/Galician_language",
    "flag": "🌐"
  },
  {
    "code": "gn",
    "alpha2": "gn",
    "alpha3": "grn",
    "family": "Tupian",
    "name": "Guaraní",
    "nativeName": "Avañe'ẽ",
    "wikiUrl": "https://en.wikipedia.org/wiki/Guaran%C3%AD_language",
    "flag": "🌐"
  },
  {
    "code": "gu",
    "alpha2": "gu",
    "alpha3": "guj",
    "family": "Indo-European",
    "name": "Gujarati",
    "nativeName": "ગુજરાતી",
    "wikiUrl": "https://en.wikipedia.org/wiki/Gujarati_language",
    "flag": "🌐"
  },
  {
    "code": "gv",
    "alpha2": "gv",
    "alpha3": "glv",
    "family": "Indo-European",
    "name": "Manx",
    "nativeName": "Gaelg, Gailck",
    "wikiUrl": "https://en.wikipedia.org/wiki/Manx_language",
    "flag": "🌐"
  },
  {
    "code": "ha",
    "alpha2": "ha",
    "alpha3": "hau",
    "family": "Afro-Asiatic",
    "name": "Hausa",
    "nativeName": "(Hausa) هَوُسَ",
    "wikiUrl": "https://en.wikipedia.org/wiki/Hausa_language",
    "flag": "🌐"
  },
  {
    "code": "he",
    "alpha2": "he",
    "alpha3": "heb",
    "family": "Afro-Asiatic",
    "name": "Hebrew (modern)",
    "nativeName": "עברית",
    "wikiUrl": "https://en.wikipedia.org/wiki/Hebrew_language",
    "flag": "🇮🇱"
  },
  {
    "code": "hi",
    "alpha2": "hi",
    "alpha3": "hin",
    "family": "Indo-European",
    "name": "Hindi",
    "nativeName": "हिन्दी, हिंदी",
    "wikiUrl": "https://en.wikipedia.org/wiki/Hindi",
    "flag": "🇮🇳"
  },
  {
    "code": "ho",
    "alpha2": "ho",
    "alpha3": "hmo",
    "family": "Austronesian",
    "name": "Hiri Motu",
    "nativeName": "Hiri Motu",
    "wikiUrl": "https://en.wikipedia.org/wiki/Hiri_Motu_language",
    "flag": "🌐"
  },
  {
    "code": "hr",
    "alpha2": "hr",
    "alpha3": "hrv",
    "family": "Indo-European",
    "name": "Croatian",
    "nativeName": "hrvatski jezik",
    "wikiUrl": "https://en.wikipedia.org/wiki/Croatian_language",
    "flag": "🌐"
  },
  {
    "code": "ht",
    "alpha2": "ht",
    "alpha3": "hat",
    "family": "Creole",
    "name": "Haitian, Haitian Creole",
    "nativeName": "Kreyòl ayisyen",
    "wikiUrl": "https://en.wikipedia.org/wiki/Haitian_Creole_language",
    "flag": "🌐"
  },
  {
    "code": "hu",
    "alpha2": "hu",
    "alpha3": "hun",
    "family": "Uralic",
    "name": "Hungarian",
    "nativeName": "magyar",
    "wikiUrl": "https://en.wikipedia.org/wiki/Hungarian_language",
    "flag": "🌐"
  },
  {
    "code": "hy",
    "alpha2": "hy",
    "alpha3": "hye",
    "family": "Indo-European",
    "name": "Armenian",
    "nativeName": "Հայերեն",
    "wikiUrl": "https://en.wikipedia.org/wiki/Armenian_language",
    "flag": "🌐"
  },
  {
    "code": "hz",
    "alpha2": "hz",
    "alpha3": "her",
    "family": "Niger–Congo",
    "name": "Herero",
    "nativeName": "Otjiherero",
    "wikiUrl": "https://en.wikipedia.org/wiki/Herero_language",
    "flag": "🌐"
  },
  {
    "code": "ia",
    "alpha2": "ia",
    "alpha3": "ina",
    "family": "Constructed",
    "name": "Interlingua",
    "nativeName": "Interlingua",
    "wikiUrl": "https://en.wikipedia.org/wiki/Interlingua",
    "flag": "🌐"
  },
  {
    "code": "id",
    "alpha2": "id",
    "alpha3": "ind",
    "family": "Austronesian",
    "name": "Indonesian",
    "nativeName": "Bahasa Indonesia",
    "wikiUrl": "https://en.wikipedia.org/wiki/Indonesian_language",
    "flag": "🌐"
  },
  {
    "code": "ie",
    "alpha2": "ie",
    "alpha3": "ile",
    "family": "Constructed",
    "name": "Interlingue",
    "nativeName": "Originally called Occidental; then Interlingue after WWII",
    "wikiUrl": "https://en.wikipedia.org/wiki/Interlingue_language",
    "flag": "🌐"
  },
  {
    "code": "ig",
    "alpha2": "ig",
    "alpha3": "ibo",
    "family": "Niger–Congo",
    "name": "Igbo",
    "nativeName": "Asụsụ Igbo",
    "wikiUrl": "https://en.wikipedia.org/wiki/Igbo_language",
    "flag": "🌐"
  },
  {
    "code": "ii",
    "alpha2": "ii",
    "alpha3": "iii",
    "family": "Sino-Tibetan",
    "name": "Nuosu",
    "nativeName": "ꆈꌠ꒿ Nuosuhxop",
    "wikiUrl": "https://en.wikipedia.org/wiki/Nuosu_language",
    "flag": "🌐"
  },
  {
    "code": "ik",
    "alpha2": "ik",
    "alpha3": "ipk",
    "family": "Eskimo–Aleut",
    "name": "Inupiaq",
    "nativeName": "Iñupiaq, Iñupiatun",
    "wikiUrl": "https://en.wikipedia.org/wiki/Inupiaq_language",
    "flag": "🌐"
  },
  {
    "code": "io",
    "alpha2": "io",
    "alpha3": "ido",
    "family": "Constructed",
    "name": "Ido",
    "nativeName": "Ido",
    "wikiUrl": "https://en.wikipedia.org/wiki/Ido_(language)",
    "flag": "🌐"
  },
  {
    "code": "is",
    "alpha2": "is",
    "alpha3": "isl",
    "family": "Indo-European",
    "name": "Icelandic",
    "nativeName": "Íslenska",
    "wikiUrl": "https://en.wikipedia.org/wiki/Icelandic_language",
    "flag": "🌐"
  },
  {
    "code": "it",
    "alpha2": "it",
    "alpha3": "ita",
    "family": "Indo-European",
    "name": "Italian",
    "nativeName": "Italiano",
    "wikiUrl": "https://en.wikipedia.org/wiki/Italian_language",
    "flag": "🇮🇹"
  },
  {
    "code": "iu",
    "alpha2": "iu",
    "alpha3": "iku",
    "family": "Eskimo–Aleut",
    "name": "Inuktitut",
    "nativeName": "ᐃᓄᒃᑎᑐᑦ",
    "wikiUrl": "https://en.wikipedia.org/wiki/Inuktitut",
    "flag": "🌐"
  },
  {
    "code": "ja",
    "alpha2": "ja",
    "alpha3": "jpn",
    "family": "Japonic",
    "name": "Japanese",
    "nativeName": "日本語 (にほんご)",
    "wikiUrl": "https://en.wikipedia.org/wiki/Japanese_language",
    "flag": "🇯🇵"
  },
  {
    "code": "jv",
    "alpha2": "jv",
    "alpha3": "jav",
    "family": "Austronesian",
    "name": "Javanese",
    "nativeName": "ꦧꦱꦗꦮ, Basa Jawa",
    "wikiUrl": "https://en.wikipedia.org/wiki/Javanese_language",
    "flag": "🌐"
  },
  {
    "code": "ka",
    "alpha2": "ka",
    "alpha3": "kat",
    "family": "South Caucasian",
    "name": "Georgian",
    "nativeName": "ქართული",
    "wikiUrl": "https://en.wikipedia.org/wiki/Georgian_language",
    "flag": "🌐"
  },
  {
    "code": "kg",
    "alpha2": "kg",
    "alpha3": "kon",
    "family": "Niger–Congo",
    "name": "Kongo",
    "nativeName": "Kikongo",
    "wikiUrl": "https://en.wikipedia.org/wiki/Kongo_language",
    "flag": "🌐"
  },
  {
    "code": "ki",
    "alpha2": "ki",
    "alpha3": "kik",
    "family": "Niger–Congo",
    "name": "Kikuyu, Gikuyu",
    "nativeName": "Gĩkũyũ",
    "wikiUrl": "https://en.wikipedia.org/wiki/Gikuyu_language",
    "flag": "🌐"
  },
  {
    "code": "kj",
    "alpha2": "kj",
    "alpha3": "kua",
    "family": "Niger–Congo",
    "name": "Kwanyama, Kuanyama",
    "nativeName": "Kuanyama",
    "wikiUrl": "https://en.wikipedia.org/wiki/Kwanyama",
    "flag": "🌐"
  },
  {
    "code": "kk",
    "alpha2": "kk",
    "alpha3": "kaz",
    "family": "Turkic",
    "name": "Kazakh",
    "nativeName": "қазақ тілі",
    "wikiUrl": "https://en.wikipedia.org/wiki/Kazakh_language",
    "flag": "🌐"
  },
  {
    "code": "kl",
    "alpha2": "kl",
    "alpha3": "kal",
    "family": "Eskimo–Aleut",
    "name": "Kalaallisut, Greenlandic",
    "nativeName": "kalaallisut, kalaallit oqaasii",
    "wikiUrl": "https://en.wikipedia.org/wiki/Kalaallisut_language",
    "flag": "🌐"
  },
  {
    "code": "km",
    "alpha2": "km",
    "alpha3": "khm",
    "family": "Austroasiatic",
    "name": "Khmer",
    "nativeName": "ខ្មែរ, ខេមរភាសា, ភាសាខ្មែរ",
    "wikiUrl": "https://en.wikipedia.org/wiki/Khmer_language",
    "flag": "🌐"
  },
  {
    "code": "kn",
    "alpha2": "kn",
    "alpha3": "kan",
    "family": "Dravidian",
    "name": "Kannada",
    "nativeName": "ಕನ್ನಡ",
    "wikiUrl": "https://en.wikipedia.org/wiki/Kannada_language",
    "flag": "🌐"
  },
  {
    "code": "ko",
    "alpha2": "ko",
    "alpha3": "kor",
    "family": "Koreanic",
    "name": "Korean",
    "nativeName": "한국어",
    "wikiUrl": "https://en.wikipedia.org/wiki/Korean_language",
    "flag": "🇰🇷"
  },
  {
    "code": "kr",
    "alpha2": "kr",
    "alpha3": "kau",
    "family": "Nilo-Saharan",
    "name": "Kanuri",
    "nativeName": "Kanuri",
    "wikiUrl": "https://en.wikipedia.org/wiki/Kanuri_language",
    "flag": "🌐"
  },
  {
    "code": "ks",
    "alpha2": "ks",
    "alpha3": "kas",
    "family": "Indo-European",
    "name": "Kashmiri",
    "nativeName": "कश्मीरी, كشميري‎",
    "wikiUrl": "https://en.wikipedia.org/wiki/Kashmiri_language",
    "flag": "🌐"
  },
  {
    "code": "ku",
    "alpha2": "ku",
    "alpha3": "kur",
    "family": "Indo-European",
    "name": "Kurdish",
    "nativeName": "Kurdî, كوردی‎",
    "wikiUrl": "https://en.wikipedia.org/wiki/Kurdish_language",
    "flag": "🌐"
  },
  {
    "code": "kv",
    "alpha2": "kv",
    "alpha3": "kom",
    "family": "Uralic",
    "name": "Komi",
    "nativeName": "коми кыв",
    "wikiUrl": "https://en.wikipedia.org/wiki/Komi_language",
    "flag": "🌐"
  },
  {
    "code": "kw",
    "alpha2": "kw",
    "alpha3": "cor",
    "family": "Indo-European",
    "name": "Cornish",
    "nativeName": "Kernewek",
    "wikiUrl": "https://en.wikipedia.org/wiki/Cornish_language",
    "flag": "🌐"
  },
  {
    "code": "ky",
    "alpha2": "ky",
    "alpha3": "kir",
    "family": "Turkic",
    "name": "Kyrgyz",
    "nativeName": "Кыргызча, Кыргыз тили",
    "wikiUrl": "https://en.wikipedia.org/wiki/Kyrgyz_language",
    "flag": "🌐"
  },
  {
    "code": "la",
    "alpha2": "la",
    "alpha3": "lat",
    "family": "Indo-European",
    "name": "Latin",
    "nativeName": "latine, lingua latina",
    "wikiUrl": "https://en.wikipedia.org/wiki/Latin",
    "flag": "🌐"
  },
  {
    "code": "lb",
    "alpha2": "lb",
    "alpha3": "ltz",
    "family": "Indo-European",
    "name": "Luxembourgish, Letzeburgesch",
    "nativeName": "Lëtzebuergesch",
    "wikiUrl": "https://en.wikipedia.org/wiki/Luxembourgish_language",
    "flag": "🌐"
  },
  {
    "code": "lg",
    "alpha2": "lg",
    "alpha3": "lug",
    "family": "Niger–Congo",
    "name": "Ganda",
    "nativeName": "Luganda",
    "wikiUrl": "https://en.wikipedia.org/wiki/Luganda",
    "flag": "🌐"
  },
  {
    "code": "li",
    "alpha2": "li",
    "alpha3": "lim",
    "family": "Indo-European",
    "name": "Limburgish, Limburgan, Limburger",
    "nativeName": "Limburgs",
    "wikiUrl": "https://en.wikipedia.org/wiki/Limburgish_language",
    "flag": "🌐"
  },
  {
    "code": "ln",
    "alpha2": "ln",
    "alpha3": "lin",
    "family": "Niger–Congo",
    "name": "Lingala",
    "nativeName": "Lingála",
    "wikiUrl": "https://en.wikipedia.org/wiki/Lingala_language",
    "flag": "🌐"
  },
  {
    "code": "lo",
    "alpha2": "lo",
    "alpha3": "lao",
    "family": "Tai–Kadai",
    "name": "Lao",
    "nativeName": "ພາສາລາວ",
    "wikiUrl": "https://en.wikipedia.org/wiki/Lao_language",
    "flag": "🌐"
  },
  {
    "code": "lt",
    "alpha2": "lt",
    "alpha3": "lit",
    "family": "Indo-European",
    "name": "Lithuanian",
    "nativeName": "lietuvių kalba",
    "wikiUrl": "https://en.wikipedia.org/wiki/Lithuanian_language",
    "flag": "🌐"
  },
  {
    "code": "lu",
    "alpha2": "lu",
    "alpha3": "lub",
    "family": "Niger–Congo",
    "name": "Luba-Katanga",
    "nativeName": "Tshiluba",
    "wikiUrl": "https://en.wikipedia.org/wiki/Tshiluba_language",
    "flag": "🌐"
  },
  {
    "code": "lv",
    "alpha2": "lv",
    "alpha3": "lav",
    "family": "Indo-European",
    "name": "Latvian",
    "nativeName": "latviešu valoda",
    "wikiUrl": "https://en.wikipedia.org/wiki/Latvian_language",
    "flag": "🌐"
  },
  {
    "code": "mg",
    "alpha2": "mg",
    "alpha3": "mlg",
    "family": "Austronesian",
    "name": "Malagasy",
    "nativeName": "fiteny malagasy",
    "wikiUrl": "https://en.wikipedia.org/wiki/Malagasy_language",
    "flag": "🌐"
  },
  {
    "code": "mh",
    "alpha2": "mh",
    "alpha3": "mah",
    "family": "Austronesian",
    "name": "Marshallese",
    "nativeName": "Kajin M̧ajeļ",
    "wikiUrl": "https://en.wikipedia.org/wiki/Marshallese_language",
    "flag": "🌐"
  },
  {
    "code": "mi",
    "alpha2": "mi",
    "alpha3": "mri",
    "family": "Austronesian",
    "name": "Māori",
    "nativeName": "te reo Māori",
    "wikiUrl": "https://en.wikipedia.org/wiki/M%C4%81ori_language",
    "flag": "🌐"
  },
  {
    "code": "mk",
    "alpha2": "mk",
    "alpha3": "mkd",
    "family": "Indo-European",
    "name": "Macedonian",
    "nativeName": "македонски јазик",
    "wikiUrl": "https://en.wikipedia.org/wiki/Macedonian_language",
    "flag": "🌐"
  },
  {
    "code": "ml",
    "alpha2": "ml",
    "alpha3": "mal",
    "family": "Dravidian",
    "name": "Malayalam",
    "nativeName": "മലയാളം",
    "wikiUrl": "https://en.wikipedia.org/wiki/Malayalam_language",
    "flag": "🌐"
  },
  {
    "code": "mn",
    "alpha2": "mn",
    "alpha3": "mon",
    "family": "Mongolic",
    "name": "Mongolian",
    "nativeName": "Монгол хэл",
    "wikiUrl": "https://en.wikipedia.org/wiki/Mongolian_language",
    "flag": "🌐"
  },
  {
    "code": "mr",
    "alpha2": "mr",
    "alpha3": "mar",
    "family": "Indo-European",
    "name": "Marathi (Marāṭhī)",
    "nativeName": "मराठी",
    "wikiUrl": "https://en.wikipedia.org/wiki/Marathi_language",
    "flag": "🌐"
  },
  {
    "code": "ms",
    "alpha2": "ms",
    "alpha3": "msa",
    "family": "Austronesian",
    "name": "Malay",
    "nativeName": "bahasa Melayu, بهاس ملايو‎",
    "wikiUrl": "https://en.wikipedia.org/wiki/Malay_language",
    "flag": "🌐"
  },
  {
    "code": "mt",
    "alpha2": "mt",
    "alpha3": "mlt",
    "family": "Afro-Asiatic",
    "name": "Maltese",
    "nativeName": "Malti",
    "wikiUrl": "https://en.wikipedia.org/wiki/Maltese_language",
    "flag": "🌐"
  },
  {
    "code": "my",
    "alpha2": "my",
    "alpha3": "mya",
    "family": "Sino-Tibetan",
    "name": "Burmese",
    "nativeName": "ဗမာစာ",
    "wikiUrl": "https://en.wikipedia.org/wiki/Burmese_language",
    "flag": "🌐"
  },
  {
    "code": "na",
    "alpha2": "na",
    "alpha3": "nau",
    "family": "Austronesian",
    "name": "Nauruan",
    "nativeName": "Dorerin Naoero",
    "wikiUrl": "https://en.wikipedia.org/wiki/Nauruan_language",
    "flag": "🌐"
  },
  {
    "code": "nb",
    "alpha2": "nb",
    "alpha3": "nob",
    "family": "Indo-European",
    "name": "Norwegian Bokmål",
    "nativeName": "Norsk bokmål",
    "wikiUrl": "https://en.wikipedia.org/wiki/Bokm%C3%A5l",
    "flag": "🌐"
  },
  {
    "code": "nd",
    "alpha2": "nd",
    "alpha3": "nde",
    "family": "Niger–Congo",
    "name": "Northern Ndebele",
    "nativeName": "isiNdebele",
    "wikiUrl": "https://en.wikipedia.org/wiki/Northern_Ndebele_language",
    "flag": "🌐"
  },
  {
    "code": "ne",
    "alpha2": "ne",
    "alpha3": "nep",
    "family": "Indo-European",
    "name": "Nepali",
    "nativeName": "नेपाली",
    "wikiUrl": "https://en.wikipedia.org/wiki/Nepali_language",
    "flag": "🌐"
  },
  {
    "code": "ng",
    "alpha2": "ng",
    "alpha3": "ndo",
    "family": "Niger–Congo",
    "name": "Ndonga",
    "nativeName": "Owambo",
    "wikiUrl": "https://en.wikipedia.org/wiki/Ndonga",
    "flag": "🌐"
  },
  {
    "code": "nl",
    "alpha2": "nl",
    "alpha3": "nld",
    "family": "Indo-European",
    "name": "Dutch",
    "nativeName": "Nederlands, Vlaams",
    "wikiUrl": "https://en.wikipedia.org/wiki/Dutch_language",
    "flag": "🇳🇱"
  },
  {
    "code": "nn",
    "alpha2": "nn",
    "alpha3": "nno",
    "family": "Indo-European",
    "name": "Norwegian Nynorsk",
    "nativeName": "Norsk nynorsk",
    "wikiUrl": "https://en.wikipedia.org/wiki/Nynorsk",
    "flag": "🌐"
  },
  {
    "code": "no",
    "alpha2": "no",
    "alpha3": "nor",
    "family": "Indo-European",
    "name": "Norwegian",
    "nativeName": "Norsk",
    "wikiUrl": "https://en.wikipedia.org/wiki/Norwegian_language",
    "flag": "🇳🇴"
  },
  {
    "code": "nr",
    "alpha2": "nr",
    "alpha3": "nbl",
    "family": "Niger–Congo",
    "name": "Southern Ndebele",
    "nativeName": "isiNdebele",
    "wikiUrl": "https://en.wikipedia.org/wiki/Southern_Ndebele_language",
    "flag": "🌐"
  },
  {
    "code": "nv",
    "alpha2": "nv",
    "alpha3": "nav",
    "family": "Dené–Yeniseian",
    "name": "Navajo, Navaho",
    "nativeName": "Diné bizaad",
    "wikiUrl": "https://en.wikipedia.org/wiki/Navajo_language",
    "flag": "🌐"
  },
  {
    "code": "ny",
    "alpha2": "ny",
    "alpha3": "nya",
    "family": "Niger–Congo",
    "name": "Chichewa, Chewa, Nyanja",
    "nativeName": "chiCheŵa, chinyanja",
    "wikiUrl": "https://en.wikipedia.org/wiki/Chichewa_language",
    "flag": "🌐"
  },
  {
    "code": "oc",
    "alpha2": "oc",
    "alpha3": "oci",
    "family": "Indo-European",
    "name": "Occitan",
    "nativeName": "occitan, lenga d'òc",
    "wikiUrl": "https://en.wikipedia.org/wiki/Occitan_language",
    "flag": "🌐"
  },
  {
    "code": "oj",
    "alpha2": "oj",
    "alpha3": "oji",
    "family": "Algonquian",
    "name": "Ojibwe, Ojibwa",
    "nativeName": "ᐊᓂᔑᓈᐯᒧᐎᓐ",
    "wikiUrl": "https://en.wikipedia.org/wiki/Ojibwe_language",
    "flag": "🌐"
  },
  {
    "code": "om",
    "alpha2": "om",
    "alpha3": "orm",
    "family": "Afro-Asiatic",
    "name": "Oromo",
    "nativeName": "Afaan Oromoo",
    "wikiUrl": "https://en.wikipedia.org/wiki/Oromo_language",
    "flag": "🌐"
  },
  {
    "code": "or",
    "alpha2": "or",
    "alpha3": "ori",
    "family": "Indo-European",
    "name": "Oriya",
    "nativeName": "ଓଡ଼ିଆ",
    "wikiUrl": "https://en.wikipedia.org/wiki/Oriya_language",
    "flag": "🌐"
  },
  {
    "code": "os",
    "alpha2": "os",
    "alpha3": "oss",
    "family": "Indo-European",
    "name": "Ossetian, Ossetic",
    "nativeName": "ирон æвзаг",
    "wikiUrl": "https://en.wikipedia.org/wiki/Ossetic_language",
    "flag": "🌐"
  },
  {
    "code": "pa",
    "alpha2": "pa",
    "alpha3": "pan",
    "family": "Indo-European",
    "name": "(Eastern) Punjabi",
    "nativeName": "ਪੰਜਾਬੀ",
    "wikiUrl": "https://en.wikipedia.org/wiki/Eastern_Punjabi_language",
    "flag": "🌐"
  },
  {
    "code": "pi",
    "alpha2": "pi",
    "alpha3": "pli",
    "family": "Indo-European",
    "name": "Pāli",
    "nativeName": "पाऴि",
    "wikiUrl": "https://en.wikipedia.org/wiki/P%C4%81li_language",
    "flag": "🌐"
  },
  {
    "code": "pl",
    "alpha2": "pl",
    "alpha3": "pol",
    "family": "Indo-European",
    "name": "Polish",
    "nativeName": "język polski, polszczyzna",
    "wikiUrl": "https://en.wikipedia.org/wiki/Polish_language",
    "flag": "🇵🇱"
  },
  {
    "code": "ps",
    "alpha2": "ps",
    "alpha3": "pus",
    "family": "Indo-European",
    "name": "Pashto, Pushto",
    "nativeName": "پښتو",
    "wikiUrl": "https://en.wikipedia.org/wiki/Pashto_language",
    "flag": "🌐"
  },
  {
    "code": "pt",
    "alpha2": "pt",
    "alpha3": "por",
    "family": "Indo-European",
    "name": "Portuguese",
    "nativeName": "Português",
    "wikiUrl": "https://en.wikipedia.org/wiki/Portuguese_language",
    "flag": "🇵🇹"
  },
  {
    "code": "qu",
    "alpha2": "qu",
    "alpha3": "que",
    "family": "Quechuan",
    "name": "Quechua",
    "nativeName": "Runa Simi, Kichwa",
    "wikiUrl": "https://en.wikipedia.org/wiki/Quechua_language",
    "flag": "🌐"
  },
  {
    "code": "rm",
    "alpha2": "rm",
    "alpha3": "roh",
    "family": "Indo-European",
    "name": "Romansh",
    "nativeName": "rumantsch grischun",
    "wikiUrl": "https://en.wikipedia.org/wiki/Romansh_language",
    "flag": "🌐"
  },
  {
    "code": "rn",
    "alpha2": "rn",
    "alpha3": "run",
    "family": "Niger–Congo",
    "name": "Kirundi",
    "nativeName": "Ikirundi",
    "wikiUrl": "https://en.wikipedia.org/wiki/Kirundi",
    "flag": "🌐"
  },
  {
    "code": "ro",
    "alpha2": "ro",
    "alpha3": "ron",
    "family": "Indo-European",
    "name": "Romanian",
    "nativeName": "Română",
    "wikiUrl": "https://en.wikipedia.org/wiki/Romanian_language",
    "flag": "🌐"
  },
  {
    "code": "ru",
    "alpha2": "ru",
    "alpha3": "rus",
    "family": "Indo-European",
    "name": "Russian",
    "nativeName": "Русский",
    "wikiUrl": "https://en.wikipedia.org/wiki/Russian_language",
    "flag": "🇷🇺"
  },
  {
    "code": "rw",
    "alpha2": "rw",
    "alpha3": "kin",
    "family": "Niger–Congo",
    "name": "Kinyarwanda",
    "nativeName": "Ikinyarwanda",
    "wikiUrl": "https://en.wikipedia.org/wiki/Kinyarwanda",
    "flag": "🌐"
  },
  {
    "code": "sa",
    "alpha2": "sa",
    "alpha3": "san",
    "family": "Indo-European",
    "name": "Sanskrit (Saṁskṛta)",
    "nativeName": "संस्कृतम्",
    "wikiUrl": "https://en.wikipedia.org/wiki/Sanskrit",
    "flag": "🌐"
  },
  {
    "code": "sc",
    "alpha2": "sc",
    "alpha3": "srd",
    "family": "Indo-European",
    "name": "Sardinian",
    "nativeName": "sardu",
    "wikiUrl": "https://en.wikipedia.org/wiki/Sardinian_language",
    "flag": "🌐"
  },
  {
    "code": "sd",
    "alpha2": "sd",
    "alpha3": "snd",
    "family": "Indo-European",
    "name": "Sindhi",
    "nativeName": "सिन्धी, سنڌي، سندھی‎",
    "wikiUrl": "https://en.wikipedia.org/wiki/Sindhi_language",
    "flag": "🌐"
  },
  {
    "code": "se",
    "alpha2": "se",
    "alpha3": "sme",
    "family": "Uralic",
    "name": "Northern Sami",
    "nativeName": "Davvisámegiella",
    "wikiUrl": "https://en.wikipedia.org/wiki/Northern_Sami",
    "flag": "🌐"
  },
  {
    "code": "sg",
    "alpha2": "sg",
    "alpha3": "sag",
    "family": "Creole",
    "name": "Sango",
    "nativeName": "yângâ tî sängö",
    "wikiUrl": "https://en.wikipedia.org/wiki/Sango_language",
    "flag": "🌐"
  },
  {
    "code": "si",
    "alpha2": "si",
    "alpha3": "sin",
    "family": "Indo-European",
    "name": "Sinhalese, Sinhala",
    "nativeName": "සිංහල",
    "wikiUrl": "https://en.wikipedia.org/wiki/Sinhalese_language",
    "flag": "🌐"
  },
  {
    "code": "sk",
    "alpha2": "sk",
    "alpha3": "slk",
    "family": "Indo-European",
    "name": "Slovak",
    "nativeName": "slovenčina, slovenský jazyk",
    "wikiUrl": "https://en.wikipedia.org/wiki/Slovak_language",
    "flag": "🌐"
  },
  {
    "code": "sl",
    "alpha2": "sl",
    "alpha3": "slv",
    "family": "Indo-European",
    "name": "Slovene",
    "nativeName": "slovenski jezik, slovenščina",
    "wikiUrl": "https://en.wikipedia.org/wiki/Slovene_language",
    "flag": "🌐"
  },
  {
    "code": "sm",
    "alpha2": "sm",
    "alpha3": "smo",
    "family": "Austronesian",
    "name": "Samoan",
    "nativeName": "gagana fa'a Samoa",
    "wikiUrl": "https://en.wikipedia.org/wiki/Samoan_language",
    "flag": "🌐"
  },
  {
    "code": "sn",
    "alpha2": "sn",
    "alpha3": "sna",
    "family": "Niger–Congo",
    "name": "Shona",
    "nativeName": "chiShona",
    "wikiUrl": "https://en.wikipedia.org/wiki/Shona_language",
    "flag": "🌐"
  },
  {
    "code": "so",
    "alpha2": "so",
    "alpha3": "som",
    "family": "Afro-Asiatic",
    "name": "Somali",
    "nativeName": "Soomaaliga, af Soomaali",
    "wikiUrl": "https://en.wikipedia.org/wiki/Somali_language",
    "flag": "🌐"
  },
  {
    "code": "sq",
    "alpha2": "sq",
    "alpha3": "sqi",
    "family": "Indo-European",
    "name": "Albanian",
    "nativeName": "Shqip",
    "wikiUrl": "https://en.wikipedia.org/wiki/Albanian_language",
    "flag": "🌐"
  },
  {
    "code": "sr",
    "alpha2": "sr",
    "alpha3": "srp",
    "family": "Indo-European",
    "name": "Serbian",
    "nativeName": "српски језик",
    "wikiUrl": "https://en.wikipedia.org/wiki/Serbian_language",
    "flag": "🌐"
  },
  {
    "code": "ss",
    "alpha2": "ss",
    "alpha3": "ssw",
    "family": "Niger–Congo",
    "name": "Swati",
    "nativeName": "SiSwati",
    "wikiUrl": "https://en.wikipedia.org/wiki/Swati_language",
    "flag": "🌐"
  },
  {
    "code": "st",
    "alpha2": "st",
    "alpha3": "sot",
    "family": "Niger–Congo",
    "name": "Southern Sotho",
    "nativeName": "Sesotho",
    "wikiUrl": "https://en.wikipedia.org/wiki/Sotho_language",
    "flag": "🌐"
  },
  {
    "code": "su",
    "alpha2": "su",
    "alpha3": "sun",
    "family": "Austronesian",
    "name": "Sundanese",
    "nativeName": "Basa Sunda",
    "wikiUrl": "https://en.wikipedia.org/wiki/Sundanese_language",
    "flag": "🌐"
  },
  {
    "code": "sv",
    "alpha2": "sv",
    "alpha3": "swe",
    "family": "Indo-European",
    "name": "Swedish",
    "nativeName": "svenska",
    "wikiUrl": "https://en.wikipedia.org/wiki/Swedish_language",
    "flag": "🇸🇪"
  },
  {
    "code": "sw",
    "alpha2": "sw",
    "alpha3": "swa",
    "family": "Niger–Congo",
    "name": "Swahili",
    "nativeName": "Kiswahili",
    "wikiUrl": "https://en.wikipedia.org/wiki/Swahili_language",
    "flag": "🌐"
  },
  {
    "code": "ta",
    "alpha2": "ta",
    "alpha3": "tam",
    "family": "Dravidian",
    "name": "Tamil",
    "nativeName": "தமிழ்",
    "wikiUrl": "https://en.wikipedia.org/wiki/Tamil_language",
    "flag": "🌐"
  },
  {
    "code": "te",
    "alpha2": "te",
    "alpha3": "tel",
    "family": "Dravidian",
    "name": "Telugu",
    "nativeName": "తెలుగు",
    "wikiUrl": "https://en.wikipedia.org/wiki/Telugu_language",
    "flag": "🌐"
  },
  {
    "code": "tg",
    "alpha2": "tg",
    "alpha3": "tgk",
    "family": "Indo-European",
    "name": "Tajik",
    "nativeName": "тоҷикӣ, toçikī, تاجیکی‎",
    "wikiUrl": "https://en.wikipedia.org/wiki/Tajik_language",
    "flag": "🌐"
  },
  {
    "code": "th",
    "alpha2": "th",
    "alpha3": "tha",
    "family": "Tai–Kadai",
    "name": "Thai",
    "nativeName": "ไทย",
    "wikiUrl": "https://en.wikipedia.org/wiki/Thai_language",
    "flag": "🇹🇭"
  },
  {
    "code": "ti",
    "alpha2": "ti",
    "alpha3": "tir",
    "family": "Afro-Asiatic",
    "name": "Tigrinya",
    "nativeName": "ትግርኛ",
    "wikiUrl": "https://en.wikipedia.org/wiki/Tigrinya_language",
    "flag": "🌐"
  },
  {
    "code": "tk",
    "alpha2": "tk",
    "alpha3": "tuk",
    "family": "Turkic",
    "name": "Turkmen",
    "nativeName": "Türkmen, Түркмен",
    "wikiUrl": "https://en.wikipedia.org/wiki/Turkmen_language",
    "flag": "🌐"
  },
  {
    "code": "tl",
    "alpha2": "tl",
    "alpha3": "tgl",
    "family": "Austronesian",
    "name": "Tagalog",
    "nativeName": "Wikang Tagalog",
    "wikiUrl": "https://en.wikipedia.org/wiki/Tagalog_language",
    "flag": "🌐"
  },
  {
    "code": "tn",
    "alpha2": "tn",
    "alpha3": "tsn",
    "family": "Niger–Congo",
    "name": "Tswana",
    "nativeName": "Setswana",
    "wikiUrl": "https://en.wikipedia.org/wiki/Tswana_language",
    "flag": "🌐"
  },
  {
    "code": "to",
    "alpha2": "to",
    "alpha3": "ton",
    "family": "Austronesian",
    "name": "Tonga (Tonga Islands)",
    "nativeName": "faka Tonga",
    "wikiUrl": "https://en.wikipedia.org/wiki/Tongan_language",
    "flag": "🌐"
  },
  {
    "code": "tr",
    "alpha2": "tr",
    "alpha3": "tur",
    "family": "Turkic",
    "name": "Turkish",
    "nativeName": "Türkçe",
    "wikiUrl": "https://en.wikipedia.org/wiki/Turkish_language",
    "flag": "🇹🇷"
  },
  {
    "code": "ts",
    "alpha2": "ts",
    "alpha3": "tso",
    "family": "Niger–Congo",
    "name": "Tsonga",
    "nativeName": "Xitsonga",
    "wikiUrl": "https://en.wikipedia.org/wiki/Tsonga_language",
    "flag": "🌐"
  },
  {
    "code": "tt",
    "alpha2": "tt",
    "alpha3": "tat",
    "family": "Turkic",
    "name": "Tatar",
    "nativeName": "татар теле, tatar tele",
    "wikiUrl": "https://en.wikipedia.org/wiki/Tatar_language",
    "flag": "🌐"
  },
  {
    "code": "tw",
    "alpha2": "tw",
    "alpha3": "twi",
    "family": "Niger–Congo",
    "name": "Twi",
    "nativeName": "Twi",
    "wikiUrl": "https://en.wikipedia.org/wiki/Twi",
    "flag": "🌐"
  },
  {
    "code": "ty",
    "alpha2": "ty",
    "alpha3": "tah",
    "family": "Austronesian",
    "name": "Tahitian",
    "nativeName": "Reo Tahiti",
    "wikiUrl": "https://en.wikipedia.org/wiki/Tahitian_language",
    "flag": "🌐"
  },
  {
    "code": "ug",
    "alpha2": "ug",
    "alpha3": "uig",
    "family": "Turkic",
    "name": "Uyghur",
    "nativeName": "ئۇيغۇرچە‎, Uyghurche",
    "wikiUrl": "https://en.wikipedia.org/wiki/Uyghur_language",
    "flag": "🌐"
  },
  {
    "code": "uk",
    "alpha2": "uk",
    "alpha3": "ukr",
    "family": "Indo-European",
    "name": "Ukrainian",
    "nativeName": "Українська",
    "wikiUrl": "https://en.wikipedia.org/wiki/Ukrainian_language",
    "flag": "🇺🇦"
  },
  {
    "code": "ur",
    "alpha2": "ur",
    "alpha3": "urd",
    "family": "Indo-European",
    "name": "Urdu",
    "nativeName": "اردو",
    "wikiUrl": "https://en.wikipedia.org/wiki/Urdu",
    "flag": "🌐"
  },
  {
    "code": "uz",
    "alpha2": "uz",
    "alpha3": "uzb",
    "family": "Turkic",
    "name": "Uzbek",
    "nativeName": "Oʻzbek, Ўзбек, أۇزبېك‎",
    "wikiUrl": "https://en.wikipedia.org/wiki/Uzbek_language",
    "flag": "🌐"
  },
  {
    "code": "ve",
    "alpha2": "ve",
    "alpha3": "ven",
    "family": "Niger–Congo",
    "name": "Venda",
    "nativeName": "Tshivenḓa",
    "wikiUrl": "https://en.wikipedia.org/wiki/Venda_language",
    "flag": "🌐"
  },
  {
    "code": "vi",
    "alpha2": "vi",
    "alpha3": "vie",
    "family": "Austroasiatic",
    "name": "Vietnamese",
    "nativeName": "Tiếng Việt",
    "wikiUrl": "https://en.wikipedia.org/wiki/Vietnamese_language",
    "flag": "🌐"
  },
  {
    "code": "vo",
    "alpha2": "vo",
    "alpha3": "vol",
    "family": "Constructed",
    "name": "Volapük",
    "nativeName": "Volapük",
    "wikiUrl": "https://en.wikipedia.org/wiki/Volap%C3%BCk",
    "flag": "🌐"
  },
  {
    "code": "wa",
    "alpha2": "wa",
    "alpha3": "wln",
    "family": "Indo-European",
    "name": "Walloon",
    "nativeName": "walon",
    "wikiUrl": "https://en.wikipedia.org/wiki/Walloon_language",
    "flag": "🌐"
  },
  {
    "code": "wo",
    "alpha2": "wo",
    "alpha3": "wol",
    "family": "Niger–Congo",
    "name": "Wolof",
    "nativeName": "Wollof",
    "wikiUrl": "https://en.wikipedia.org/wiki/Wolof_language",
    "flag": "🌐"
  },
  {
    "code": "xh",
    "alpha2": "xh",
    "alpha3": "xho",
    "family": "Niger–Congo",
    "name": "Xhosa",
    "nativeName": "isiXhosa",
    "wikiUrl": "https://en.wikipedia.org/wiki/Xhosa_language",
    "flag": "🌐"
  },
  {
    "code": "yi",
    "alpha2": "yi",
    "alpha3": "yid",
    "family": "Indo-European",
    "name": "Yiddish",
    "nativeName": "ייִדיש",
    "wikiUrl": "https://en.wikipedia.org/wiki/Yiddish_language",
    "flag": "🌐"
  },
  {
    "code": "yo",
    "alpha2": "yo",
    "alpha3": "yor",
    "family": "Niger–Congo",
    "name": "Yoruba",
    "nativeName": "Yorùbá",
    "wikiUrl": "https://en.wikipedia.org/wiki/Yoruba_language",
    "flag": "🌐"
  },
  {
    "code": "za",
    "alpha2": "za",
    "alpha3": "zha",
    "family": "Tai–Kadai",
    "name": "Zhuang, Chuang",
    "nativeName": "Saɯ cueŋƅ, Saw cuengh",
    "wikiUrl": "https://en.wikipedia.org/wiki/Zhuang_languages",
    "flag": "🌐"
  },
  {
    "code": "zh",
    "alpha2": "zh",
    "alpha3": "zho",
    "family": "Sino-Tibetan",
    "name": "Chinese",
    "nativeName": "中文 (Zhōngwén), 汉语, 漢語",
    "wikiUrl": "https://en.wikipedia.org/wiki/Chinese_language",
    "flag": "🇨🇳"
  },
  {
    "code": "zu",
    "alpha2": "zu",
    "alpha3": "zul",
    "family": "Niger–Congo",
    "name": "Zulu",
    "nativeName": "isiZulu",
    "wikiUrl": "https://en.wikipedia.org/wiki/Zulu_language",
    "flag": "🌐"
  }
];
